export default __webpack_public_path__ + "static/media/USAA.43755a85.svg";